import type { PluginFeatures } from '@kirin/api-client/contracts/plugins';

export function hasAnyEntityFeatures(
  features: PluginFeatures | null | undefined
): boolean {
  if (!features) return false;
  return Boolean(
    features.commands?.length ||
    features.agents?.length ||
    features.skills?.length ||
    features.mcpServers?.length ||
    features.hooks?.length ||
    features.monitors?.length ||
    features.themes?.length
  );
}

export function hasAnyFileFeatures(
  features: PluginFeatures | null | undefined
): boolean {
  if (!features) return false;
  return Boolean(
    features.files?.executables?.length || features.files?.instructions?.length
  );
}

export function hasAnyPluginFeatures(
  features: PluginFeatures | null | undefined
): boolean {
  return hasAnyEntityFeatures(features) || hasAnyFileFeatures(features);
}
